import React, { PropTypes } from 'react';

import LoadingSpinner from '../../../shared/js/components/LoadingSpinner';

import { sortBy } from 'lodash';
import { propertyHasChanged } from '../lib/objectComparison';

import '../../styles/SelectGlobalThing';

class SelectGlobalSchool extends React.Component {
	componentWillMount() {
		// If a list of schools already exists in the app state, don't bother to re-fetch
		if (this.props.schools && this.props.schools.length) {
			// If no school is selected in the props, but one is saved in localStorage, select it
			if (localStorage.getItem('school') && !this.props.selectedSchool) {
				this.restoreSchoolFromLocalStorage();
			}
		} else {
			this.props.fetchSchools().then(this.restoreSchoolFromLocalStorage.bind(this));
		}
	}

	componentDidMount() {
		this.initializeDropdown();
	}

	componentWillReceiveProps(newProps) {
		if (this.props.selectedSchool && propertyHasChanged(newProps.selectedSchool, this.props.selectedSchool)) {
			// If a school was already selected, clear the selected classrooms
			this.props.selectClassroom(null);
			this.props.selectStudent(null);
		}
	}

	componentDidUpdate() {
		this.initializeDropdown();
	}

	getFilteredSchools() {
		if (this.props.schools && this.props.schools.length && this.props.selectedDistrict) {
			let schools = this.props.schools.filter((school) => school.district_id === this.props.selectedDistrict.id);

			return sortBy(schools, 'name');
		} else {
			return [];
		}
	}

	initializeDropdown() {
		$('.select-global-thing.select-global-school .ui.dropdown').dropdown({
			action: 'hide',
			onChange: this.selectSchoolById.bind(this),
			placeholder: 'Select school'
		});

		if (this.props.selectedSchool) {
			$('.select-global-school .ui.dropdown').dropdown('set selected', this.props.selectedSchool.id);
		} else {
			$('.select-global-school .ui.dropdown').dropdown('clear');
		}
	}

	restoreSchoolFromLocalStorage() {
		const selectedSchoolId = localStorage.getItem('school');

		if (selectedSchoolId) {
			this.selectSchoolById(selectedSchoolId);
		}
	}

	selectSchoolById(schoolId) {
		let isNewSchool = !this.props.selectedSchool || (this.props.selectedSchool.id.toString() !== schoolId.toString());

		if (this.props.schools && isNewSchool) {
			this.props.schools.every((school) => {
				if (school.id.toString() === schoolId.toString()) {
					this.props.selectSchool(school);
					return false;
				} else {
					return true;
				}
			});
		}
	}

	isDisabled() {
		return this.props.isFetchingDistricts || this.props.isFetchingSchools || this.props.disabled;
	}

	render() {
		const filteredSchools = this.getFilteredSchools();

		return (
			<div className="select-global-thing select-global-school">
				<div className={ `ui floating dropdown labeled search icon button fluid${ this.isDisabled() ? ' disabled' : '' }` }>
					<i />
					<div className="icon-left">S</div>
					<div className="default text">Select school</div>
					<div className="menu">
						{
							filteredSchools ? (
								sortBy(filteredSchools, 'name').map((school) => {
									return (
										<div
											className="item"
											data-value={ school.id }
											key={ `select-global-school-option-${ school.id }` }
										>
											{ school.name }
										</div>
									);
								})
							) : ''
						}
					</div>
					<div className="icon-right">
						{
							this.props.isFetchingDistricts || this.props.isFetchingSchools ? (
								<LoadingSpinner />
							) : (
								<i className="fas fa-caret-down" />
							)
						}
					</div>
				</div>
			</div>
		);
	}
}

SelectGlobalSchool.propTypes = {
	disabled: PropTypes.bool,
	fetchSchools: PropTypes.func.isRequired,
	isFetchingDistricts: PropTypes.bool,
	isFetchingSchools: PropTypes.bool,
	schools: PropTypes.array,
	selectClassroom: PropTypes.func.isRequired,
	selectedDistrict: PropTypes.object,
	selectedSchool: PropTypes.object,
	selectSchool: PropTypes.func.isRequired,
	selectStudent: PropTypes.func
};
SelectGlobalSchool.displayName = 'SelectGlobalSchool';

export default SelectGlobalSchool;



// WEBPACK FOOTER //
// ./frontend/a2i/js/components/SelectGlobalSchool.jsx